const tradeEventsView = {
  tabs: {
    events: 'Events',
    inbox: 'Inbox',
  },
  sidebar: {
    all: 'All',
    aggregateTypes: {
      booking: 'Booking',
      load: 'Load',
      salesOrder: 'Sales Order',
      purchaseOrder: 'Purchase Order',
    },
  },
  list: {
    empty: 'No events found',
    idPrefix: 'ID:',
    notAvailable: 'N/A',
  },
  detail: {
    empty: 'Select an event to view details',
    metadata: {
      title: 'Metadata',
      eventId: 'Event ID',
      aggregateId: 'Aggregate ID',
      topic: 'Topic',
      version: 'Version',
      retryCount: 'Retry Count',
      createdAt: 'Created At',
      createdBy: 'Created By',
      lastRetry: 'Last Retry',
    },
    payload: 'Payload',
    notAvailable: 'N/A',
    toggle: {
      details: 'Details',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Previous',
      currentLabel: 'Current',
      noChanges: 'No changes detected',
    },
    eventTypes: {
      salesOrder: {
        created: 'Sales Order Created',
        updated: 'Sales Order Updated',
        deleted: 'Sales Order Deleted',
        statusChanged: 'Sales Order Status Changed',
      },
      booking: {
        created: 'Booking Created',
        updated: 'Booking Updated',
        deleted: 'Booking Deleted',
        statusChanged: 'Booking Status Changed',
      },
      load: {
        created: 'Load Created',
        updated: 'Load Updated',
        deleted: 'Load Deleted',
        statusChanged: 'Load Status Changed',
      },
      purchaseOrder: {
        created: 'Purchase Order Created',
        updated: 'Purchase Order Updated',
        deleted: 'Purchase Order Deleted',
        statusChanged: 'Purchase Order Status Changed',
      },
    },
    fields: {
      id: 'ID',
      documentNumber: 'Document Number',
      type: 'Type',
      status: 'Status',
      facilityId: 'Facility ID',
      accountId: 'Account ID',
      contactId: 'Contact ID',
      counterpartyReference: 'Counterparty Reference',
      paymentCurrency: 'Payment Currency',
      startDate: 'Start Date',
      endDate: 'End Date',
      scheduledDate: 'Scheduled Date',
      bookingId: 'Booking ID',
      salesOrderId: 'Sales Order ID',
      lineItems: 'Line Items',
      itemId: 'Item ID',
      quantity: 'Quantity',
      unit: 'Unit',
      changes: 'Changes',
      statusChange: 'Status Change',
      noDataAvailable: 'No data available',
    },
  },
  filter: {
    selectBooking: 'Filter by Booking',
    selectLoad: 'Filter by Load',
    selectSalesOrder: 'Filter by Sales Order',
    selectPurchaseOrder: 'Filter by Purchase Order',
  },
};

const financeEventsView = {
  tabs: {
    events: 'Events',
    inbox: 'Inbox',
  },
  sidebar: {
    all: 'All',
    aggregateTypes: {
      bill: 'Bill',
      invoice: 'Invoice',
    },
  },
  list: {
    empty: 'No events found',
    idPrefix: 'ID:',
    notAvailable: 'N/A',
  },
  detail: {
    empty: 'Select an event to view details',
    metadata: {
      title: 'Metadata',
      eventId: 'Event ID',
      aggregateId: 'Aggregate ID',
      topic: 'Topic',
      version: 'Version',
      retryCount: 'Retry Count',
      createdAt: 'Created At',
      createdBy: 'Created By',
      lastRetry: 'Last Retry',
    },
    payload: 'Payload',
    notAvailable: 'N/A',
    toggle: {
      details: 'Details',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Previous',
      currentLabel: 'Current',
      noChanges: 'No changes detected',
    },
    eventTypes: {
      bill: {
        created: 'Bill Created',
        updated: 'Bill Updated',
        deleted: 'Bill Deleted',
        voided: 'Bill Voided',
        paid: 'Bill Paid',
      },
      invoice: {
        created: 'Invoice Created',
        updated: 'Invoice Updated',
        deleted: 'Invoice Deleted',
        voided: 'Invoice Voided',
        paid: 'Invoice Paid',
      },
    },
    fields: {
      id: 'ID',
      documentNumber: 'Document Number',
      type: 'Type',
      status: 'Status',
      amount: 'Amount',
      documentDate: 'Document Date',
      dueDate: 'Due Date',
      eligibleAt: 'Eligible At',
      facilityId: 'Facility ID',
      accountId: 'Account ID',
      creatorId: 'Creator ID',
      paymentTerm: 'Payment Term',
      paymentMethod: 'Payment Method',
      notes: 'Notes',
      changes: 'Changes',
      statusChange: 'Status Change',
      noDataAvailable: 'No data available',
    },
  },
  filter: {
    selectBill: 'Filter by Bill',
    selectInvoice: 'Filter by Invoice',
  },
};

const crmEventsView = {
  tabs: {
    events: 'Events',
    inbox: 'Inbox',
  },
  sidebar: {
    all: 'All',
    aggregateTypes: {
      account: 'Account',
      contact: 'Contact',
    },
  },
  list: {
    empty: 'No events found',
    idPrefix: 'ID:',
    notAvailable: 'N/A',
  },
  detail: {
    empty: 'Select an event to view details',
    metadata: {
      title: 'Metadata',
      eventId: 'Event ID',
      aggregateId: 'Aggregate ID',
      topic: 'Topic',
      version: 'Version',
      retryCount: 'Retry Count',
      createdAt: 'Created At',
      createdBy: 'Created By',
      lastRetry: 'Last Retry',
    },
    payload: 'Payload',
    notAvailable: 'N/A',
    toggle: {
      details: 'Details',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Previous',
      currentLabel: 'Current',
      noChanges: 'No changes detected',
    },
    eventTypes: {
      account: {
        created: 'Account Created',
        updated: 'Account Updated',
        deleted: 'Account Deleted',
      },
      contact: {
        created: 'Contact Created',
        updated: 'Contact Updated',
        deleted: 'Contact Deleted',
      },
    },
    fields: {
      id: 'ID',
      name: 'Name',
      type: 'Type',
      accountType: 'Account Type',
      isCustomer: 'Is Customer',
      isSupplier: 'Is Supplier',
      email: 'Email',
      phone: 'Phone',
      fullName: 'Full Name',
      role: 'Role',
      department: 'Department',
      accountId: 'Account ID',
      changes: 'Changes',
      noDataAvailable: 'No data available',
    },
  },
  filter: {
    selectAccount: 'Filter by Account',
    selectContact: 'Filter by Contact',
  },
};

const assistantEventsView = {
  tabs: {
    events: 'Events',
    inbox: 'Inbox',
  },
  sidebar: {
    all: 'All',
    aggregateTypes: {
      chat: 'Chat',
      chatMessage: 'Chat Message',
    },
  },
  list: {
    empty: 'No events found',
    idPrefix: 'ID:',
    notAvailable: 'N/A',
  },
  detail: {
    empty: 'Select an event to view details',
    metadata: {
      title: 'Metadata',
      eventId: 'Event ID',
      aggregateId: 'Aggregate ID',
      topic: 'Topic',
      version: 'Version',
      retryCount: 'Retry Count',
      createdAt: 'Created At',
      createdBy: 'Created By',
      lastRetry: 'Last Retry',
    },
    payload: 'Payload',
    notAvailable: 'N/A',
    toggle: {
      details: 'Details',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Previous',
      currentLabel: 'Current',
      noChanges: 'No changes detected',
    },
    eventTypes: {
      chat: {
        created: 'Chat Created',
        updated: 'Chat Updated',
        archived: 'Chat Archived',
        titleUpdated: 'Chat Title Updated',
      },
      chatMessage: {
        created: 'Chat Message Created',
      },
    },
    fields: {
      id: 'ID',
      title: 'Title',
      status: 'Status',
      agentId: 'Agent ID',
      userId: 'User ID',
      chatId: 'Chat ID',
      role: 'Role',
      parts: 'Parts',
      changes: 'Changes',
      noDataAvailable: 'No data available',
    },
  },
  filter: {
    selectChat: 'Filter by Chat',
    selectChatMessage: 'Filter by Chat Message',
  },
};

const filesEventsView = {
  tabs: {
    events: 'Events',
    inbox: 'Inbox',
  },
  sidebar: {
    all: 'All',
    aggregateTypes: {
      file: 'File',
    },
  },
  list: {
    empty: 'No events found',
    idPrefix: 'ID:',
    notAvailable: 'N/A',
  },
  detail: {
    empty: 'Select an event to view details',
    metadata: {
      title: 'Metadata',
      eventId: 'Event ID',
      aggregateId: 'Aggregate ID',
      topic: 'Topic',
      version: 'Version',
      retryCount: 'Retry Count',
      createdAt: 'Created At',
      createdBy: 'Created By',
      lastRetry: 'Last Retry',
    },
    payload: 'Payload',
    notAvailable: 'N/A',
    toggle: {
      details: 'Details',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Previous',
      currentLabel: 'Current',
      noChanges: 'No changes detected',
    },
    eventTypes: {
      file: {
        created: 'File Created',
        accessed: 'File Accessed',
        deleted: 'File Deleted',
        quotaExceeded: 'File Quota Exceeded',
        moved: 'File Moved',
        permissionChanged: 'File Permission Changed',
        setAsTemplate: 'File Set As Template',
        removedFromTemplate: 'File Removed From Template',
      },
    },
    fields: {
      id: 'ID',
      fileName: 'File Name',
      fileSize: 'File Size',
      mimeType: 'MIME Type',
      status: 'Status',
      entityType: 'Entity Type',
      entityId: 'Entity ID',
      creatorId: 'Creator ID',
      parentId: 'Parent ID',
      fileType: 'File Type',
      public: 'Public',
      accessType: 'Access Type',
      ipAddress: 'IP Address',
      userAgent: 'User Agent',
      reason: 'Reason',
      oldParentId: 'Old Parent ID',
      newParentId: 'New Parent ID',
      permission: 'Permission',
      action: 'Action',
      templateId: 'Template ID',
      description: 'Description',
      attemptedSize: 'Attempted Size',
      currentUsage: 'Current Usage',
      quotaLimit: 'Quota Limit',
      changes: 'Changes',
      noDataAvailable: 'No data available',
    },
  },
  filter: {
    selectFile: 'Filter by File',
  },
};

const coreEventsView = {
  tabs: {
    events: 'Events',
    inbox: 'Inbox',
  },
  sidebar: {
    all: 'All',
    aggregateTypes: {
      organization: 'Organization',
      user: 'User',
      facility: 'Facility',
      facilityGroup: 'Facility Group',
    },
  },
  list: {
    empty: 'No events found',
    idPrefix: 'ID:',
    notAvailable: 'N/A',
  },
  detail: {
    empty: 'Select an event to view details',
    metadata: {
      title: 'Metadata',
      eventId: 'Event ID',
      aggregateId: 'Aggregate ID',
      topic: 'Topic',
      version: 'Version',
      retryCount: 'Retry Count',
      createdAt: 'Created At',
      createdBy: 'Created By',
      lastRetry: 'Last Retry',
    },
    payload: 'Payload',
    notAvailable: 'N/A',
    toggle: {
      details: 'Details',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Previous',
      currentLabel: 'Current',
      noChanges: 'No changes detected',
    },
    eventTypes: {
      facility: {
        created: 'Facility Created',
        updated: 'Facility Updated',
        deleted: 'Facility Deleted',
        groupAssigned: 'Facility Group Assigned',
        groupRemoved: 'Facility Group Removed',
      },
      facilityGroup: {
        created: 'Facility Group Created',
        updated: 'Facility Group Updated',
        deleted: 'Facility Group Deleted',
      },
      user: {
        created: 'User Created',
        updated: 'User Updated',
        addedToOrganization: 'User Added to Organization',
        removedFromOrganization: 'User Removed from Organization',
        invited: 'User Invited',
        adminGranted: 'Admin Granted',
        adminRevoked: 'Admin Revoked',
      },
      organization: {
        created: 'Organization Created',
        updated: 'Organization Updated',
        deleted: 'Organization Deleted',
        provisioned: 'Organization Provisioned',
        entitlementGranted: 'Entitlement Granted',
        entitlementRevoked: 'Entitlement Revoked',
        signupCompleted: 'Signup Completed',
      },
    },
    fields: {
      id: 'ID',
      name: 'Name',
      type: 'Type',
      email: 'Email',
      domain: 'Domain',
      timezone: 'Timezone',
      firstName: 'First Name',
      lastName: 'Last Name',
      phoneNumber: 'Phone Number',
      facilityName: 'Facility Name',
      facilityType: 'Facility Type',
      facilityGroupId: 'Facility Group ID',
      organizationId: 'Organization ID',
      userId: 'User ID',
      facilityId: 'Facility ID',
      entitlement: 'Entitlement',
      address: 'Address',
      changes: 'Changes',
      noDataAvailable: 'No data available',
    },
  },
  filter: {
    selectOrganization: 'Filter by Organization',
    selectUser: 'Filter by User',
    selectFacility: 'Filter by Facility',
    selectFacilityGroup: 'Filter by Facility Group',
  },
};

const inventoryEventsView = {
  tabs: {
    events: 'Events',
    inbox: 'Inbox',
  },
  sidebar: {
    all: 'All',
    aggregateTypes: {
      item: 'Item',
      category: 'Category',
      itemGroup: 'Item Group',
      inventoryTag: 'Inventory Tag',
    },
  },
  list: {
    empty: 'No events found',
    idPrefix: 'ID:',
    notAvailable: 'N/A',
  },
  detail: {
    empty: 'Select an event to view details',
    metadata: {
      title: 'Metadata',
      eventId: 'Event ID',
      aggregateId: 'Aggregate ID',
      topic: 'Topic',
      version: 'Version',
      retryCount: 'Retry Count',
      createdAt: 'Created At',
      createdBy: 'Created By',
      lastRetry: 'Last Retry',
    },
    payload: 'Payload',
    notAvailable: 'N/A',
    toggle: {
      details: 'Details',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Previous',
      currentLabel: 'Current',
      noChanges: 'No changes detected',
    },
    eventTypes: {
      item: {
        created: 'Item Created',
        updated: 'Item Updated',
        deleted: 'Item Deleted',
      },
      category: {
        created: 'Category Created',
        updated: 'Category Updated',
        deleted: 'Category Deleted',
      },
      itemGroup: {
        created: 'Item Group Created',
        updated: 'Item Group Updated',
        deleted: 'Item Group Deleted',
      },
      inventoryTag: {
        created: 'Inventory Tag Created',
        updated: 'Inventory Tag Updated',
        deleted: 'Inventory Tag Deleted',
      },
    },
    fields: {
      id: 'ID',
      name: 'Name',
      description: 'Description',
      notes: 'Notes',
      skuNumber: 'SKU Number',
      categoryId: 'Category ID',
      itemGroupId: 'Item Group ID',
      parentId: 'Parent ID',
      number: 'Number',
      tagNumber: 'Tag Number',
      tagType: 'Tag Type',
      status: 'Status',
      grossQuantity: 'Gross Quantity',
      tare: 'Tare',
      itemId: 'Item ID',
      facilityId: 'Facility ID',
      isRevised: 'Is Revised',
      quantityCaptureMethod: 'Quantity Capture Method',
      tareCaptureMethod: 'Tare Capture Method',
      generatedAt: 'Generated At',
      changes: 'Changes',
      noDataAvailable: 'No data available',
      attributes: 'Attributes',
      dataType: 'Data Type',
      required: 'Required',
      validationExpr: 'Validation Expression',
      options: 'Options',
    },
  },
  filter: {
    selectItem: 'Filter by Item',
    selectCategory: 'Filter by Category',
    selectItemGroup: 'Filter by Item Group',
    selectInventoryTag: 'Filter by Inventory Tag',
  },
};

const transportationEventsView = {
  tabs: {
    events: 'Events',
    inbox: 'Inbox',
  },
  sidebar: {
    all: 'All',
    aggregateTypes: {
      asset: 'Asset',
      driver: 'Driver',
      truck: 'Truck',
      trailer: 'Trailer',
      route: 'Route',
      service: 'Service',
      containerType: 'Container Type',
      transportationType: 'Transportation Type',
      freightForwarder: 'Freight Forwarder',
      freightLine: 'Freight Line',
      shippingCarrier: 'Shipping Carrier',
    },
  },
  list: {
    empty: 'No events found',
    idPrefix: 'ID:',
    notAvailable: 'N/A',
  },
  detail: {
    empty: 'Select an event to view details',
    metadata: {
      title: 'Metadata',
      eventId: 'Event ID',
      aggregateId: 'Aggregate ID',
      topic: 'Topic',
      version: 'Version',
      retryCount: 'Retry Count',
      createdAt: 'Created At',
      createdBy: 'Created By',
      lastRetry: 'Last Retry',
    },
    payload: 'Payload',
    notAvailable: 'N/A',
    toggle: {
      details: 'Details',
      json: 'JSON',
    },
    diff: {
      previousLabel: 'Previous',
      currentLabel: 'Current',
      noChanges: 'No changes detected',
    },
    eventTypes: {
      asset: {
        created: 'Asset Created',
        updated: 'Asset Updated',
        deleted: 'Asset Deleted',
      },
      driver: {
        created: 'Driver Created',
        updated: 'Driver Updated',
        deleted: 'Driver Deleted',
        certificationAdded: 'Driver Certification Added',
        certificationUpdated: 'Driver Certification Updated',
        certificationDeleted: 'Driver Certification Deleted',
      },
      truck: {
        created: 'Truck Created',
        updated: 'Truck Updated',
        deleted: 'Truck Deleted',
      },
      trailer: {
        created: 'Trailer Created',
        updated: 'Trailer Updated',
        deleted: 'Trailer Deleted',
      },
      route: {
        created: 'Route Created',
        updated: 'Route Updated',
        deleted: 'Route Deleted',
        statusChanged: 'Route Status Changed',
      },
      service: {
        created: 'Service Created',
        updated: 'Service Updated',
        deleted: 'Service Deleted',
        statusChanged: 'Service Status Changed',
      },
    },
    fields: {
      id: 'ID',
      documentNumber: 'Document Number',
      type: 'Type',
      status: 'Status',
      name: 'Name',
      description: 'Description',
      notes: 'Notes',
      licensePlate: 'License Plate',
      licensePlateExpiration: 'License Plate Expiration',
      vin: 'VIN',
      capacity: 'Capacity',
      country: 'Country',
      state: 'State',
      currentLocation: 'Current Location',
      lastLocationTime: 'Last Location Time',
      transportationTypeId: 'Transportation Type ID',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      licenseNumber: 'License Number',
      licenseExpiration: 'License Expiration',
      dateOfBirth: 'Date of Birth',
      hireDate: 'Hire Date',
      terminationDate: 'Termination Date',
      rank: 'Rank',
      priority: 'Priority',
      routeDate: 'Route Date',
      startedAt: 'Started At',
      completedAt: 'Completed At',
      assignedAt: 'Assigned At',
      estimatedArrival: 'Estimated Arrival',
      facilityGroupId: 'Facility Group ID',
      driverId: 'Driver ID',
      haulerId: 'Hauler ID',
      truckId: 'Truck ID',
      trailerId: 'Trailer ID',
      routeId: 'Route ID',
      facilityId: 'Facility ID',
      accountId: 'Account ID',
      contactId: 'Contact ID',
      scheduledWindowStart: 'Scheduled Window Start',
      scheduledWindowEnd: 'Scheduled Window End',
      changes: 'Changes',
      statusChange: 'Status Change',
      noDataAvailable: 'No data available',
    },
  },
  filter: {
    selectAsset: 'Filter by Asset',
    selectDriver: 'Filter by Driver',
    selectTruck: 'Filter by Truck',
    selectTrailer: 'Filter by Trailer',
    selectRoute: 'Filter by Route',
    selectService: 'Filter by Service',
  },
};

const routes = {
  title: 'Audit Log',
  notImplemented: 'Not implemented yet',
  groups: {
    modules: 'Modules',
  },
  modules: {
    trade: 'Trade',
    finance: 'Finance',
    transportation: 'Transportation',
    crm: 'CRM',
    core: 'Core',
    inventory: 'Inventory',
    assistant: 'Assistant',
    files: 'Files',
  },
};

const filters = {
  dateRange: {
    label: 'Date Range',
    clear: 'Clear',
  },
};

const pagination = {
  of: 'of',
};

export const en = {
  tradeEventsView,
  financeEventsView,
  crmEventsView,
  assistantEventsView,
  filesEventsView,
  inventoryEventsView,
  coreEventsView,
  transportationEventsView,
  routes,
  filters,
  pagination,
};
